import ModalEditTable from '../CRUDUtils/ModalEditTable';
import { Link } from 'react-router-dom';

export default function ConfigsPage() {
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name)
    }
  ];

  const formFields = [
    {
      name: 'id',
      label: 'Config ID',
      type: 'textarea',
      placeholder: 'Data ID',
      disabled: true,
    },
    {
      name: 'name',
      label: 'Name',
      type: 'textarea',
      placeholder: 'name',
      rules: [{ required: true, message: 'Must Enter a Data Type name!' }]
    },
    {
      name: 'Usernames',
      type: 'divider',
    },
    {
      name: ['data','periscope_username'],
      label: 'Periscope Username',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    {
      name: ['data','ovms_username'],
      label: 'OVMS Username',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    {
      name: ['data','camera_username'],
      label: 'Camera Username',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    {
      name: ['data','customer'],
      label: 'Customer',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    {
      name: 'Missing Footwear',
      type: 'divider',
    },
    {
      name: ['data','footwear_local'],
      label: 'Camera Username',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    {
      name: ['data','footwear_classes','positive'],
      label: 'Positive Label',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }],
      group:"boots_label"
    },
    {
      name: ['data','footwear_classes','negative'],
      label: 'Negative Label',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }],
      group:"boots_label"
    },
    {
    name: ['data', 'classification_settings', 'footwear', 'classification_lookbacks'],
    label: 'Footwear Lookbacks',
    type: 'integer',
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'boots'
  },
  {
    name: ['data', 'classification_settings', 'footwear', 'classification_conf_threshold'],
    label: 'Footwear Conf.',
    type: 'number',
    step: 0.01,
    precision: 2,
    min: 0.0,
    max: 1.0,
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'boots'
  },
  {
    name: ['data', 'classification_settings', 'footwear', 'min_pixel_count'],
    label: 'Footwear Min Pixels',
    type: 'integer',
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'boots'
  },
    {
      name: 'Missing Hardhat',
      type: 'divider',
    },
    {
      name: ['data','hardhat_local'],
      label: 'Hardhat Local',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    {
      name: ['data','hardhat_classes','positive'],
      label: 'Positive Label',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }],
      group:"hardhat_label"
    },
    {
      name: ['data','hardhat_classes','negative'],
      label: 'Negative Label',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }],
      group:"hardhat_label"
    },
    {
    name: ['data', 'classification_settings', 'missing_hard_hat', 'classification_lookbacks'],
    label: 'Missing HH Lookbacks',
    type: 'integer',
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'hardhat'
  },
  {
    name: ['data', 'classification_settings', 'missing_hard_hat', 'classification_conf_threshold'],
    label: 'Missing HH Conf.',
    type: 'number',
    step: 0.01,
    precision: 2,
    min: 0.0,
    max: 1.0,
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'hardhat'
  },
  {
    name: ['data', 'classification_settings', 'missing_hard_hat', 'min_pixel_count'],
    label: 'Missing HH Min Pixels',
    type: 'integer',
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'hardhat'
  },
    {
      name: 'Hardhat Color',
      type: 'divider',
    },
    {
      name: ['data','hardhat_color_local'],
      label: 'Hardhat Color Local',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    {
      name: ['data','colored_hardhat_classes','positive'],
      label: 'Positive Label',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }],
      group:"colored_hardhat"
    },
    {
      name: ['data','colored_hardhat_classes','negative'],
      label: 'Positive Label',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }],
      group:"colored_hardhat"
    },
    {
      name: ['data', 'hardhat_color_classes', 'positive'],
      label: 'Hardhat Color Positive Labels',
      type: 'list',
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    {
      name: 'Missing Vest',
      type: 'divider',
    },
    {
      name: ['data','vest_local'],
      label: 'Vest Local',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    {
      name: ['data','vest_classes','positive'],
      label: 'Positive Label',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }],
      group:"vest_labels"
    },
    {
      name: ['data','vest_classes','negative'],
      label: 'Negative Label',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }],
      group:"vest_labels"
    },
     {
    name: ['data', 'classification_settings', 'missing_vest', 'classification_lookbacks'],
    label: 'Missing Vest Lookbacks',
    type: 'integer',
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'class_vest'
  },
  {
    name: ['data', 'classification_settings', 'missing_vest', 'classification_conf_threshold'],
    label: 'Missing Vest Conf.',
    type: 'number',
    step: 0.01,
    precision: 2,
    min: 0.0,
    max: 1.0,
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'class_vest'
  },
  {
    name: ['data', 'classification_settings', 'missing_vest', 'min_pixel_count'],
    label: 'Missing Vest Min Pixels',
    type: 'integer',
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'class_vest'
  },
    {
      name: 'Spotter',
      type: 'divider',
    },
    {
      name: ['data','vehicle_orientation_local'],
      label: 'Pose Estimation Local',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    
    {
      name: ['data', 'spotter_classes', 'positive'],
      label: 'Spotter Positive Label',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }],
      group: 'spotter_label'
    },
    {
      name: ['data', 'spotter_classes', 'negative'],
      label: 'Spotter Negative Label',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }],
      group: 'spotter_label'
    },
          {
      name: ['data','no_spotter_distance_meters'],
      label: 'No Spotter Distance (m)',
      type: 'number',
      step: 2,         // Allow one decimal
      precision: 1,      // Show one decimal place
      min: 0,
      max: 100,
      rules: [{ required: true, message: 'Must Enter Data' }],
      group:"spotter_label"
    },

    {
    name: ['data', 'classification_settings', 'nospotter', 'classification_lookbacks'],
    label: 'No Spotter Lookbacks',
    type: 'integer',
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'spotter'
  },
  {
    name: ['data', 'classification_settings', 'nospotter', 'classification_conf_threshold'],
    label: 'No Spotter Conf.',
    type: 'number',
    step: 0.01,
    precision: 2,
    min: 0.0,
    max: 1.0,
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'spotter'
  },
  {
    name: ['data', 'classification_settings', 'nospotter', 'min_pixel_count'],
    label: 'No Spotter Min Pixels',
    type: 'integer',
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'spotter'
  },

    {
      name: 'Speed',
      type: 'divider',
    },
    {
      name: ['data','speed_limit_meters_per_second'],
      label: 'Speed Limit Meters/s',
      type: 'number',
      step: 2,         // Allow one decimal
      precision: 1,      // Show one decimal place
      min: 0,
      max: 100,
      rules: [{ required: true, message: 'Must Enter Data' }],
     // group:'class_speed'
    },
     {
    name: ['data', 'classification_settings', 'speed', 'classification_lookbacks'],
    label: 'Speed Lookbacks',
    type: 'integer',
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'class_speed'
  },
  {
    name: ['data', 'classification_settings', 'speed', 'classification_conf_threshold'],
    label: 'Speed Conf.',
    type: 'number',
    step: 0.01,
    precision: 2,
    min: 0.0,
    max: 1.0,
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'class_speed'
  },
  {
    name: ['data', 'classification_settings', 'speed', 'min_pixel_count'],
    label: 'Speed Min Pixels',
    type: 'integer',
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'class_speed'
  },

    {
      name: 'Detection Settings',
      type: 'divider',
    },
    {
      name: ['data', 'detection_settings', 'movement_threshold'],
      label: 'Movement Threshold',
      type: 'number',
      step: 0.01,
      precision: 2,
      min: 0.0,
      max: 1.0,
      rules: [{ required: true, message: 'Must Enter Data' }],
      group: 'detection_settings'
    },
    {
      name: ['data', 'detection_settings', 'movement_lookbacks'],
      label: 'Movement Lookbacks',
      type: 'integer',
      rules: [{ required: true, message: 'Must Enter Data' }],
      group: 'detection_settings'
    },
    {
      name: 'First Stage',
      type: 'divider',
    },
    {
      name: ['data','stage_1_local'],
      label: 'Stage 1 Local',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    {
      name: ['data','stage_1_demo'],
      label: 'Stage 1 Demo',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    {
      name: ['data','stage_1_min_images'],
      label: 'Stage 1 Min Images',
      type: 'integer',
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    {
      name: 'Depth Estimation',
      type: 'divider',
    },
    {
      name: ['data','depth_local'],
      label: 'Depth Local',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    {
      name: ['data','depth_interval'],
      label: 'Depth Interval',
      type: 'number',
      step: 1,         // Allow one decimal
      precision: 0,      // Show one decimal place
      min: 0,
      max: 300,
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    {
      name: 'Man Down',
      type: 'divider',
    },
    {
      name: ['data','segment_local'],
      label: 'Segment Local',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    {
      name: ['data','pose_estimation_local'],
      label: 'Pose Estimation Local',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    {
      name: ['data', 'mandown_classes', 'positive'],
      label: 'Man Down Positive Label',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }],
      group: 'mandown'
    },
    {
      name: ['data', 'mandown_classes', 'negative'],
      label: 'Man Down Negative Label',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }],
      group: 'mandown'
    },
    {
      name: 'Folders & Files',
      type: 'divider',
    },
    {
      name: ['data','weights_folder'],
      label: 'Weights Folder',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    {
      name: ['data','assets_folder'],
      label: 'Assets Folder',
      type: 'endpoint',
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    {
      name: ['data','party_hat'],
      label: 'Party Hat',
      type: 'textarea',
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    {
      name: 'Debouncing & Validation',
      type: 'divider',
    },
    {
      name: ['data','debouncer_timeout'],
      label: 'Debouncer Timeout (s)',
      type: 'number',
      step: 2,         // Allow one decimal
      precision: 1,      // Show one decimal place
      min: 0,
      max: 100,
      rules: [{ required: true, message: 'Must Enter Data' }],
      group: "debouncing"
    },
    {
      name: ['data','validate_cutoff_time'],
      label: 'Validate Cutoff Time (s)',
      type: 'number',
      step: 1,         // Allow one decimal
      precision: 0,      // Show one decimal place
      min: 0,
      max: 100,
      rules: [{ required: true, message: 'Must Enter Data' }],
      group: "debouncing"
    },
      {
    name: 'Stage Image Resolutions',
    type: 'divider',
  },
  {
    name: ['data', 'stage_1_image_res', 'w'],
    label: 'Stage 1 Width (px)',
    type: 'integer',
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'stage_1_res'
  },
  {
    name: ['data', 'stage_1_image_res', 'h'],
    label: 'Stage 1 Height (px)',
    type: 'integer',
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'stage_1_res'
  },
  {
    name: ['data', 'stage_2_image_res', 'w'],
    label: 'Stage 2 Width (px)',
    type: 'integer',
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'stage_2_res'
  },
  {
    name: ['data', 'stage_2_image_res', 'h'],
    label: 'Stage 2 Height (px)',
    type: 'integer',
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'stage_2_res'
  },
  {
    name: "Person Model",
    type: 'divider',
  },
  {
    name: ['data', 'classification_settings', 'person', 'classification_lookbacks'],
    label: 'Person Lookbacks',
    type: 'integer',
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'class_person'
  },
  {
    name: ['data', 'classification_settings', 'person', 'classification_conf_threshold'],
    label: 'Person Conf.',
    type: 'number',
    step: 0.01,
    precision: 2,
    min: 0.0,
    max: 1.0,
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'class_person'
  },
  {
    name: ['data', 'classification_settings', 'person', 'min_pixel_count'],
    label: 'Person Min Pixels',
    type: 'integer',
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'class_person'
  },
  {
    name: "Vehicle",
    type: "divider",
  },
  {
    name: ['data', 'classification_settings', 'vehicle', 'classification_lookbacks'],
    label: 'Vehicle Lookbacks',
    type: 'integer',
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'class_vehicle'
  },
  {
    name: ['data', 'classification_settings', 'vehicle', 'classification_conf_threshold'],
    label: 'Vehicle Conf.',
    type: 'number',
    step: 0.01,
    precision: 2,
    min: 0.0,
    max: 1.0,
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'class_vehicle'
  },
  {
    name: ['data', 'classification_settings', 'vehicle', 'min_pixel_count'],
    label: 'Vehicle Min Pixels',
    type: 'integer',
    rules: [{ required: true, message: 'Must Enter Data' }],
    group: 'class_vehicle'
  },
    {
      name: 'Toggles',
      type: 'divider',
    },
    {
      name: ['data','show_appinfo'],
      label: 'Show App Info',
      type: 'switch',
      rules: [{ required: true, message: 'Must Enter Data' }],
      group:"toggles"
    },
    {
      name: ['data','full_stream_logging'],
      label: 'Full Stream Logging',
      type: 'switch',
      rules: [{ required: true, message: 'Must Enter Data' }],
      group:"toggles"
    },
    {
      name: ['data','headless'],
      label: 'Headless',
      type: 'switch',
      rules: [{ required: true, message: 'Must Enter Data' }],
      group:"toggles"
    },
    {
      name: ['data','report_statics'],
      label: 'Report Statics',
      type: 'switch',
      rules: [{ required: true, message: 'Must Enter Data' }],
      group:"toggles"
    },
    {
      name: 'VMS',
      type: 'divider',
    },
    {
      name: ['data','min_free_gb'],
      label: 'Min Free GB',
      type: 'number',
      step: 1,         // Allow one decimal
      precision: 0,      // Show one decimal place
      min: 0,
      max: 100,
      rules: [{ required: true, message: 'Must Enter Data' }],
      group:"vms"
    },
    {
      name: ['data','max_days'],
      label: 'Max Days',
      type: 'number',
      step: 1,         // Allow one decimal
      precision: 0,      // Show one decimal place
      min: 0,
      max: 100,
      rules: [{ required: true, message: 'Must Enter Data' }],
      group:"vms"
    },
    {
      name: ['data','max_time_offset'],
      label: 'Max Time Offset',
      type: 'number',
      step: 1,         // Allow one decimal
      precision: 0,      // Show one decimal place
      min: 0,
      max: 500,
      rules: [{ required: true, message: 'Must Enter Data' }],
      group:"vms"
    },
    {
      name: 'RTSP',
      type: 'divider',
    },
    {
      name: ['data','rtsp_sync_timeout'],
      label: 'RTSP Sync Timeout',
      type: 'number',
      step: 1,         // Allow one decimal
      precision: 2,      // Show one decimal place
      min: 0.0,
      max: 10.0,
      rules: [{ required: true, message: 'Must Enter Data' }],
      group:"rtsp"
    },
    {
      name: ['data','rtsp_error_timeout'],
      label: 'RTSP Error Timeout',
      type: 'number',
      step: 1,         // Allow one decimal
      precision: 2,      // Show one decimal place
      min: 0.0,
      max: 10.0,
      rules: [{ required: true, message: 'Must Enter Data' }],
      group:"rtsp"
    },
    {
      name: ['data','rtsp_timeout'],
      label: 'RTSP Timeout',
      type: 'number',
      step: 1,         // Allow one decimal
      precision: 1,      // Show one decimal place
      min: 0,
      max: 10,
      rules: [{ required: true, message: 'Must Enter Data' }],
      group:"rtsp"
    },
    {
      name: 'Intrinsic Properties',
      type: 'divider',
    },
    {
      name: ['data','intrinsic_properties','sensor_width_mm'],
      label: 'Sensor Width (mm)',
      type: 'number',
      step: 2,         // Allow one decimal
      precision: 2,      // Show one decimal place
      min: 0.0,
      max: 10.0,
      rules: [{ required: false, message: 'Must Enter Data' }]
    },
    {
      name: ['data','intrinsic_properties','sensor_height_mm'],
      label: 'Sensor Height (mm)',
      type: 'number',
      step: 2,         // Allow one decimal
      precision: 2,      // Show one decimal place
      min: 0.0,
      max: 10.0,
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    {
      name: ['data','intrinsic_properties','image_width_px'],
      label: 'Image Width (px)',
      type: 'number',
      step: 1,         // Allow one decimal
      precision: 0,      // Show one decimal place
      min: 0,
      max: 1920,
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
        {
      name: ['data','intrinsic_properties','image_height_px'],
      label: 'Image Height (px)',
      type: 'number',
      step: 1,         // Allow one decimal
      precision: 0,      // Show one decimal place
      min: 0.0,
      max: 1920,
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    {
      name: ['data','intrinsic_properties','focal_length_mm'],
      label: 'Focal Length (mm)',
      type: 'number',
      step: 1,         // Allow one decimal
      precision: 1,      // Show one decimal place
      min: 0.0,
      max: 10.0,
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    {
      name: ['data','intrinsic_properties','fov_degrees_width'],
      label: 'FOV Degrees Width',
      type: 'number',
      step: 2,         // Allow one decimal
      precision: 2,      // Show one decimal place
      min: 0.0,
      max: 100.0,
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
    {
      name: ['data','intrinsic_properties','fov_degrees_height'],
      label: 'FOV Degrees Height',
      type: 'number',
      step: 2,         // Allow one decimal
      precision: 2,      // Show one decimal place
      min: 0.0,
      max: 100.0,
      rules: [{ required: true, message: 'Must Enter Data' }]
    },
  ];

  return (
    <div className='container-wrapper'>
      <ModalEditTable
        createEndpoint="create/configs"
        readEndpoint="read/configs"
        editEndpoint="update/configs"
        deleteEndpoint="delete/configs"
        columns={columns}
        formFields={formFields}
        title="Configs"
      />
    </div>
  );
}